module.exports = __webpack_public_path__ + "static/media/PRESIDENTE-APV.crop.700b1de2.jpg";